import fragmentoj from './kelkaj_fragmentoj_el_la_jaro_1990';
import aliflanke from './aliflanke_de_maro';
import ioPriAmo from './io_pri_amo';
import ioPriDiverseco from './io_pri_diverseco';
import kialJaguaro from './kial_jaguaro_havas_felon_kun_makuloj';
import laBelaRozo from './la_bela_rozo';
import laCirklo from './la_cirklo';
import laEksperimento3824 from './la_eksperimento_3824';
import laTerEpizodo from './la_epizodo_el_la_vivo_de_la_tero';
import liMortisNokte from './li_mortis_nokte';
import libero from './libero';
import moviĝo from './moviĝo';
import printempajRevoj from './printempaj_revoj';
import retroviLaVojon from './retrovi_la_vojon';
import satori from './satori';
import solulo from './solulo';

import odoroDeGaso from './odoro_de_gaso';
import alvokoDeTeraIdo from './alvoko_de_tera_ido';
import junilinoElĈiĉenItca from './junulino_el_ĉiĉen-itca';
import rakontoDeĈeestinto from './rakonto_de_ĉeestinto';

import kioEstis from './kio_estis'; 
import feliĉoDeGedziĝo from './feliĉo_de_gedziĝo';
import lirikaBotaniko from './lirika_botaniko';

import printempo2020 from './printempo2020';
import reaEvoluo from './reaEvoluo';
import neoportunaSituacio from './neoportunaSituacio';
import laAmoDeLaTero from './laAmoDeLaTero';
import duHistorioj from './duHistorioj';
import senerare from './senerare';
import multajnSeksojn from './multajnSeksojn';

import dialogo_de_geedza_paro from './dialogo_de_geedza_paro';
import kiel_du_odesaninoj from './kiel_du_odesaninoj';

import amo_en_urbo from './amo_en_urbo';
import el_raporto_de_piloto from './el_raporto_de_piloto';
import fragmento_el_raporto_de_piloto from './fragmento_el_raporto_de_piloto';
import infanaj_petolaĵoj from './infanaj_petolaĵoj';
import malbeno_de_maljunuleco from './malbeno_de_maljunuleco';
import ek_al_demokratio from './ek_al_demokratio';
import nokta_vojaĝo_2 from './nokta_vojaĝo_2';
import vintre_de_2022 from './vintre_de_2022';
import sekreta_vivo_de_niaj_najbaroj from './sekreta_vivo_de_niaj_najbaroj';
import mortigo_de_mnemozina from './mortigo_de_mnemozina';
import kion_povas_kaj_ne_povas from './kion_povas_kaj_ne_povas';
import sxtupoj_de_ekkono from './sxtupoj_de_ekkono';
import por_demokratio from './por_demokratio';
import kurta_kristnaska_rakonto from './kurta_kristnaska_rakonto';
import neturista_vojaĝo_al_hispanio from './neturista_vojaĝo_al_hispanio';
import tio_kio_nin_unuecigas from './tio_kio_nin_unuecigas';
import kia_bonŝanca_mi_estas from './kia_bonŝanca_mi_estas';
import la_fina_venko from './la_fina_venko';
import la_vojo from './la_vojo';
import fragmento_el_intervjuo from './fragmento_el_intervjuo.js';
import kompleto_100_vorta from './kompleto_100_vorta.js';

const list = [
  fragmentoj,
  aliflanke,
  kialJaguaro,
  laBelaRozo,
  libero,
  laCirklo,
  laEksperimento3824,
  laTerEpizodo,
  retroviLaVojon,
  solulo,
  printempajRevoj,
  ioPriDiverseco,
  ioPriAmo,
  moviĝo,
  liMortisNokte,
  satori,
  odoroDeGaso,
  alvokoDeTeraIdo,
  junilinoElĈiĉenItca,
  rakontoDeĈeestinto,
  kioEstis,
  feliĉoDeGedziĝo,
  lirikaBotaniko,
  printempo2020,
  reaEvoluo,
  neoportunaSituacio,
  laAmoDeLaTero,
  duHistorioj,
  senerare,
  multajnSeksojn,
  dialogo_de_geedza_paro,
  kiel_du_odesaninoj,
  amo_en_urbo,
  el_raporto_de_piloto,
  fragmento_el_raporto_de_piloto,
  infanaj_petolaĵoj,
  malbeno_de_maljunuleco,
  ek_al_demokratio,
  nokta_vojaĝo_2,
  vintre_de_2022,
  sekreta_vivo_de_niaj_najbaroj,
  mortigo_de_mnemozina,
  kion_povas_kaj_ne_povas,
  sxtupoj_de_ekkono,
  por_demokratio,
  kurta_kristnaska_rakonto,
  neturista_vojaĝo_al_hispanio,
  tio_kio_nin_unuecigas,
  kia_bonŝanca_mi_estas,
  la_fina_venko,
  la_vojo,
  fragmento_el_intervjuo,
  kompleto_100_vorta
];

export default list;